export interface Firma {
  id: number;
  firma: string;
  kurzbezeichnung: string;
}
